import React, { useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import Select from "react-select";
import { makeStyles } from "@material-ui/core/styles";
import Loader from "./../../component/Loader";
import RestService from "./../../Restservice";

const useStyles = makeStyles((theme) => ({
  setSelect: {
    width: "250px",
    display: "inline-block",
    marginRight: "10px",
  },
}));

export default function SaveStock({ newSymbol, wathclist, mobile, web_token }) {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [watchlistid, setWatchlistid] = useState(0);

  const handleClose = () => {
    setOpen(false);
  };

  const getSectorData = (event) => {
    setWatchlistid(event?.value);
  };

  const onSubmit = () => {
    setLoading(true);
    let fdata = new FormData();
    fdata.append("mobile", mobile);
    fdata.append("web_token", web_token);
    fdata.append("symbol", newSymbol);
    fdata.append("watchlistid", watchlistid);
    RestService.saveStockWatchList(function (res) {
      setLoading(false);
      const response = JSON.parse(res);
      setMessage(response?.data?.message);
    }, fdata);
  };

  return (
    <>
      {loading ? <Loader /> : ""}
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="lg"
      >
        <DialogTitle id="alert-dialog-title">{`Save ${newSymbol}`}</DialogTitle>
        <DialogContent>
          {message && <p className="txtGreen">{message} </p>}
          <Select
            styles={{
              menuPortal: (base) => ({
                ...base,
                zIndex: 9999,
              }),
              width: "300px",
            }}
            menuPosition={"fixed"}
            onChange={getSectorData}
            options={wathclist}
            name="sectorid"
            className={`${classes.setSelect} select-option`}
            placeholder="Select Watchlist"
          />
        </DialogContent>
        <DialogActions>
          <Button
            disabled={watchlistid > 0 ? false : true}
            variant="contained"
            color="primary"
            onClick={onSubmit}
          >
            Submit
          </Button>
          <Button onClick={handleClose} variant="outlined">
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <div className="fixedAddButton">
        <i
          onClick={() => setOpen(true)}
          title={`Save ${newSymbol}`}
          className="fa fa fa-save save-stock"
        ></i>
      </div>
    </>
  );
}
